import {SpaGlobalConfig} from '../../generated/core';
import {MOCK_ENABLED} from '../constants';
import {getGlobal} from './getGlobal';

export const isDevMode = (config: SpaGlobalConfig) => {
    return (
        config.clientsideMockEnabled &&
        getGlobal().config.getBoolean(MOCK_ENABLED)
    );
};
